"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.feegrantTypes = void 0;
const tx_1 = require("cosmjs-types/cosmos/feegrant/v1beta1/tx");
exports.feegrantTypes = [
    ["/cosmos.feegrant.v1beta1.MsgGrantAllowance", tx_1.MsgGrantAllowance],
    ["/cosmos.feegrant.v1beta1.MsgRevokeAllowance", tx_1.MsgRevokeAllowance],
];
//# sourceMappingURL=messages.js.map